import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
import { useState, useRef, useEffect } from "react"
//import { LANGUAGES } from "../constants/languages"
//import { faGithub, faLinkedin, faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"

export default function NavBar() {
  const { t, i18n } = useTranslation()
  //const [dropdownOpen, setDropdownOpen] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrollDirection, setScrollDirection] = useState("up")
  const lastScrollY = useRef(0)
  //const dropdownRef = useRef(null)

  /*const handleLanguageSelect = (lang) => {
    i18n.changeLanguage(lang).then(() => {
      localStorage.setItem("preferredLang", lang)
      setDropdownOpen(false)
    })
  }*/

  useEffect(()=>{
    i18n.changeLanguage("en").then(() => {
      localStorage.setItem("preferredLang", "en")
    });
  },[i18n]);


  useEffect(() => {
    const handleTouchStart = (e) => {
      window.startX = e.touches[0].clientX
    }

    const handleTouchEnd = (e) => {
      const endX = e.changedTouches[0].clientX
      const diff = window.startX - endX
      if (diff > 50) setMenuOpen(false) // swipe left
    }

    if (menuOpen) {
      window.addEventListener("touchstart", handleTouchStart)
      window.addEventListener("touchend", handleTouchEnd)
    }

    return () => {
      window.removeEventListener("touchstart", handleTouchStart)
      window.removeEventListener("touchend", handleTouchEnd)
    }
  }, [menuOpen])

  useEffect(() => {
    const handleClickOutside = (e) => {
      const menu = document.querySelector(".mobile-menu")
      const icon = document.querySelector(".mobile-menu-icon")

      if (
        menu &&
        !menu.contains(e.target) &&
        icon &&
        !icon.contains(e.target)
      ) {
        setMenuOpen(false)
      }
    }

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [menuOpen])

  /*useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])*/

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY > lastScrollY.current && currentScrollY > 50) {
        setScrollDirection("down")
      } else if (currentScrollY < lastScrollY.current) {
        setScrollDirection("up")
      }

      lastScrollY.current = currentScrollY
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const navLinks = [
    { label: "navHome", path: "/" },
    { label: "navPortfolio", path: "/portfolio" },
    { label: "navAbout", path: "/about" },
    { label: "navRoadmap", path: "/roadmap" },
    { label: "navServices", path: "/services" },
    { label: "FAQs", path: "/faqs" },
    // Contact link removed from here
  ]

  return (
    <>
      <nav className={`navigator-wrapper ${scrollDirection === "down" ? "hide-navbar" : ""}`}>
        <div className="nav-inner ">
          <div className="mobile-menu-wrapper">
            <div className="mobile-menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
              <FontAwesomeIcon icon={faBars} />
            </div>
          </div>

          <Link to="/" className="logo-wrapper neon-hover ">
            <img className="logo" src="/images/logoCyan.webp" alt="bitsAndBoltsLogo" />
            <div className="logo-name-wrapper">
              <div className="logo-name-line-1">BITS & BOLTS</div>
              <div className="logo-name-line-2">FROM IDEA TO LAUNCH</div>
            </div>
          </Link>

          <div className="nav-links ">
            {navLinks.map(({ label, path, special }) => (
              <Link
                key={path}
                to={path}
                className={`nav-link  ${special ? "contact-link" : ""}`}
              >
                {t(label)}
              </Link>
            ))}
          </div>

          {/* 👇 CTA replaces language + social icons */}
          <div className="contact-link-wrapper smaller">
            <Link
              to="/quote"
              className="contact-link "
            >
              CONTACT ME{/*{t("navContact")}*/}
            </Link>
          </div>

          {/* 👇 Old language and social block — commented out */}
          {/*
          <div className="lang-and-socials-wrapper">
            <div className="custom-language-dropdown" ref={dropdownRef}>
              <span
                className="lang-label"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                LANGUAGE
              </span>
              {dropdownOpen && (
                <div className="dropdown-menu">
                  {Object.entries(LANGUAGES).map(([key, { dropdownLabel }]) => (
                    <div
                      key={key}
                      className="dropdown-item"
                      onClick={() => handleLanguageSelect(key)}
                    >
                      {dropdownLabel}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="social-icons">
              <a
                href="https://github.com/vallejoyuridamian"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} className="social-icon" />
              </a>
              <a
                href="https://www.linkedin.com/in/vallejoyuridamian"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
              </a>
              <a
                href="https://twitter.com/vallejoyuridami"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faXTwitter} className="social-icon" />
              </a>
            </div>
          </div>
          */}

          {menuOpen && (
            <div className="mobile-menu">
              <div className="mobile-menu-close" onClick={() => setMenuOpen(false)}>
                <FontAwesomeIcon icon={faXmark} />
              </div>
              {navLinks.map(({ label, path }) => (
                <Link
                  key={path}
                  to={path}
                  className="mobile-nav-link"
                  onClick={() => setMenuOpen(false)}
                >
                  {t(label)}
                </Link>
              ))}
              {/*<Link
                to="/quote"
                className="mobile-nav-link contact-link"
                onClick={() => setMenuOpen(false)}
              >
                {t("navContact")}
              </Link>*/}
            </div>
          )}
        </div>
      </nav>

      <div style={{ height: "var(--navbar-height)" }} aria-hidden="true" />
    </>
  )
}
